
namespace SorAraBul.PropertyManagement {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PropertiesDialog extends Serenity.EntityDialog<PropertiesRow, any> {
        protected getFormKey() { return PropertiesForm.formKey; }
        protected getIdProperty() { return PropertiesRow.idProperty; }
        protected getLocalTextPrefix() { return PropertiesRow.localTextPrefix; }
        protected getNameProperty() { return PropertiesRow.nameProperty; }
        protected getService() { return PropertiesService.baseUrl; }
        protected getDeletePermission() { return PropertiesRow.deletePermission; }
        protected getInsertPermission() { return PropertiesRow.insertPermission; }
        protected getUpdatePermission() { return PropertiesRow.updatePermission; }

        protected form = new PropertiesForm(this.idPrefix);
        private propertyTenantsGrid: PropertyTenantsGrid;

        constructor() {
            super();
            SorAraBul.Common.preventAutofill([
                this.form.CityId,
                this.form.IlceId,
                this.form.QuarterId
            ]);

            this.propertyTenantsGrid = new PropertyTenantsGrid(this.byId('PropertyTenantsGrid'));
            this.propertyTenantsGrid.openDialogsAsPanel = false;

        }

        loadEntity(entity: PropertiesRow) {
            super.loadEntity(entity);

            Serenity.TabsExtensions.setDisabled(this.tabs, 'PropertyTenantsGrid', this.isNewOrDeleted());

            this.propertyTenantsGrid.propertyId = entity.Id;
        }

        getTemplate() {
            return `<div id="~_Tabs" class="s-DialogContent">
    <ul>
        <li><a href="#~_TabInfo"><span>${Q.text("Db.PropertyManagement.Properties.EntitySingular")}</span></a></li>
        <li><a href="#~_TabPropertyTenantsGrid"><span>${Q.text("Db.PropertyManagement.Tenants.EntityPlural")}</span></a></li>
    </ul>
    <div id="~_TabInfo" class="tab-pane s-TabInfo">
        <div id="~_Toolbar" class="s-DialogToolbar">
        </div>
        <div class="s-Form">
            <form id="~_Form" action="">
                <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                    <div id="~_PropertyGrid"></div>
                    <div class="clear"></div>
                </div>
            </form>
        </div>
    </div>
    <div id="~_TabPropertyTenantsGrid" class="tab-pane s-TabPropertyTenantsGrid">
    <div id="~_PropertyTenantsGrid">
        </div>
    </div>
</div>`;
        }
    }


    @Serenity.Decorators.registerClass()
    export class PropertiesAsDialog extends Serenity.EntityDialog<PropertiesRow, any> {
        protected getFormKey() { return PropertiesForm.formKey; }
        protected getIdProperty() { return PropertiesRow.idProperty; }
        protected getLocalTextPrefix() { return PropertiesRow.localTextPrefix; }
        protected getNameProperty() { return PropertiesRow.nameProperty; }
        protected getService() { return PropertiesService.baseUrl; }
        protected getDeletePermission() { return PropertiesRow.deletePermission; }
        protected getInsertPermission() { return PropertiesRow.insertPermission; }
        protected getUpdatePermission() { return PropertiesRow.updatePermission; }

        protected form = new PropertiesForm(this.idPrefix);

        constructor() {
            super();
            SorAraBul.Common.preventAutofill([
                this.form.CityId,
                this.form.IlceId,
                this.form.QuarterId
            ]);
        }
    }

}
